module.exports = "<div class=\"portlet register-portlet\">\n    <header class=\"portlet-header\">\n        <h2 class=\"portlet-title\">{{controller.error.title}}</h2>\n    </header>\n    <div class=\"portlet-body padding-body\">\n        {{controller.error.description}}\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/app/error/error-page.html
// module id = 924
// module chunks = 12